module.exports = __webpack_public_path__ + "static/img/Michelle-Heyman.20e8314.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Michelle-Heyman.jpg
// module id = aZLw
// module chunks = 0